import * as moment from 'moment';
import Col from 'components/Col';
import { connect } from 'react-redux';
import Styled from 'styled-components';
import { Typography } from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';

import Page from 'components/Page';
import { getNewsPostsAction } from '../actions';
import HeaderBanner from 'components/headerBanner/HeaderBanner';
import FullScreenLoader from 'components/Loaders/FullScreenLoader';

const initialState = {
  loading: true,
  error: false,
  post: {}
};

function reducer(state, action) {
  switch (action.type) {
    case 'GET_POST':
      return { ...state, post: action.payload, loading: false };
    default:
      throw new Error();
  }
}

function NewsPost({ match, posts, getNewsPosts, authUser }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    if (posts.length < 1) {
      getNewsPosts();
    } else {
      dispatch({ type: 'GET_POST', payload: posts[match.params.key] });
    }
  }, [posts, match.params.postKey, getNewsPosts, match.params.key]);

  if (state.loading) return <FullScreenLoader />;

  return (
    <div>
      <HeaderBanner title="News" subtitle="It's all about news" />
      <Page style={{ textAlign: 'center' }}>
        <Column style={{ alignItems: 'flex-start', marginLeft: '13%' }}>
          <Typography variant="h4" style={{ textTransform: 'uppercase' }}>
            {state.post.title}
          </Typography>
          <Typography variant="caption" style={{ paddingLeft: 10 }}>
            {moment(state.post.time).format('MMMM Do YYYY, h:mma')}
          </Typography>
        </Column>
        {
          <MainImage
            src="https://images.pexels.com/photos/248797/pexels-photo-248797.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            alt=" "
            style={{ margin: 'auto' }}
          />
        }
        <NewsContent variant="body1">
          {state.post.detail +
            state.post.detail +
            state.post.detail +
            state.post.detail}
        </NewsContent>
      </Page>
    </div>
  );
}

export default connect(
  state => ({
    posts: state.newsState.posts,
    authUser: state.authState.firestoreUser
  }),
  {
    getNewsPosts: getNewsPostsAction
  }
)(NewsPost);

const NewsContent = Styled(Typography)`
&&&
{
  margin: 8px 11% 10px 14%;
  @media (max-width: 599px) {
    margin:0 0 0 10px
}
`;
const Column = Styled(Col)`
&&&
{
  margin: 8px 11% 10px 14%;
  @media (max-width: 599px) {
    margin:0 0 0 10px
}
`;

const MainImage = Styled.img`
  padding:10px;
  min-height:300px;
  max-height:calc(100vh - 68px);
   @media (max-width: 599px) {
    width: 100%;
    margin:0
  }
`;
